<template>
  <div>
    <Header />
    <!-- banner -->
    <div class="banner">
      <h1 class="banner_title">{{ $t("header.about") }}</h1>
    </div>
    <!-- 创新 安全 质量 目标 -->
    <!-- <div class="company-brief-box d-block d-md-none">
      <ul class="company_brief">
        <li class="brief_item">
          <div class="brief_img">
            <img src="../assets/image/home-1.png" class="img-fluid" alt="img" />
          </div>
          <h5>{{ $t('home.innovate') }}</h5>
          <p>{{ $t('home.innovate_txt') }}</p>
        </li>
        <li class="brief_item">
          <div class="brief_img">
            <img src="../assets/image/home-2.png" class="img-fluid" alt="img" />
          </div>
          <h5>{{ $t('home.security') }}</h5>
          <p>{{ $t('home.security_txt') }}</p>
        </li>
        <li class="brief_item">
          <div class="brief_img">
            <img src="../assets/image/home-3.png" class="img-fluid" alt="img" />
          </div>
          <h5>{{ $t('home.quality') }}</h5>
          <p>{{ $t('home.quality_txt') }}</p>
        </li>
        <li class="brief_item">
          <div class="brief_img">
            <img src="../assets/image/home-4.png" class="img-fluid" alt="img" />
          </div>
          <h5>{{ $t('home.target') }}</h5>
          <p>{{ $t('home.target_txt') }}</p>
        </li>
      </ul>
    </div> -->
    <!-- 公司文化 -->
    <div class="culture">
      <div class="title">{{ $t("about.about1") }}</div>
      <div class="container">
        <div class="culture-txt">
          <div class="culture-left">
            <p >{{ $t("about.about18") }}</p>
            <p >{{ $t("about.about15") }}</p>

          </div>
          <div class="culture-right">
            <p >{{$t("about.about17") }}</p>
            <p >{{$t("about.about19") }}</p>

          </div>
        </div>
        <div class="row culture-imgbox">
          <div class="col-md-4 col-12">
            <div class="culture-img">
              <img src="../assets/image/about-7.png" class="img-fluid" alt="" />
            </div>
          </div>
          <div class="col-md-4 col-6 culture-item1">
            <div class="culture-img">
              <img src="../assets/image/about-8.png" class="img-fluid" alt="" />
            </div>
          </div>
          <div class="col-md-4 col-6 culture-item2">
            <div class="culture-img">
              <img src="../assets/image/about-9.png" class="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="development">
      <div class="container d-md-block d-none">
        <div class="title">{{ $t("about.about23") }}</div>
        <div class="div-box">
          <div class="develop-time">
            <div class="time-item part2010">
              <p>
                {{ $t("about.about24") }}
              </p>
              <h5>2010年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>
            <div class="time-item part2014">
              <p>
                {{ $t("about.about25") }}
              </p>
              <h5>2014年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>
            <div class="time-item part2017">
              <p>
                {{ $t("about.about26") }}
              </p>
              <h5>2017年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>
            <div class="time-item part2019">
              <p>
                {{ $t("about.about27") }}
              </p>
              <h5>2019年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>
            <div class="time-item part2021">
              <p>
                {{ $t("about.about121") }}
              </p>
              <h5>2021年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>          
             <div class="time-item part2023">
              <p>
                {{ $t("about.about123") }}
              </p>
              <h5>2023年</h5>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
            </div>
          </div>
          <div class="develop-time2">
            <div class="time2-item part2012">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
              <h5>2012年</h5>
              <p>
                {{ $t("about.about28") }}
              </p>
            </div>
            <div class="time2-item part2016">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
              <h5>2016年</h5>
              <p>
                {{ $t("about.about29") }}
              </p>
            </div>
            <div class="time2-item part2018">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
              <h5>2018年</h5>
              <p>
                {{ $t("about.about30") }}
              </p>
            </div>
            <div class="time2-item part2020">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
              <h5>2020年</h5>
              <p>
                {{ $t("about.about120") }}
              </p>
            </div>
            <div class="time2-item part2022">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" class="img-fluid" />
              </div> -->
              <h5>2022年</h5>
              <p>
                {{ $t("about.about122") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="container d-sm-block d-md-none">
        <div class="title">{{ $t("about.about23") }}</div>
        <div class="develop-time-3">

          <!-- 2023 -->
          <div class="time-item item2023">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2023年</h5>
                <p>
                  {{ $t("about.about123") }}
                  <!-- 完成国内沥青混凝土心墙方量最大土石坝沥青混凝土心墙施工，并研发外出国内外最宽的沥青心墙联合摊铺机 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>
          <!-- 2022 -->
          <div class="time2-item">
            <div class="dot-box2 item2022">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
              <div class="dot-txt2">
                <h5>2022年</h5>
                <p>
                  {{ $t("about.about122") }}
                  <!-- 完成海外沥青混凝土心墙坝项目综合鲁水电站施工建设沥青混凝土心墙施工 -->
                </p>
              </div>
            </div>
          </div>
          <!-- 2021 -->
          <div class="time-item item2021">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2021年</h5>
                <p>
                  {{ $t("about.about121") }}
                  <!-- 完成国内沥青混凝土心墙方量最大土石坝沥青混凝土心墙施工，并研发外出国内外最宽的沥青心墙联合摊铺机 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>
          <!-- 2020 -->
          <div class="time2-item">
            <div class="dot-box2 item2018">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
              <div class="dot-txt2">
                <h5>2020年</h5>
                <p>
                  {{ $t("about.about120") }}
                  <!-- 完成海外沥青混凝土心墙坝项目综合鲁水电站施工建设沥青混凝土心墙施工 -->
                </p>
              </div>
            </div>
          </div>

          <!-- 2019 -->
          <div class="time-item item2019">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2019年</h5>
                <p>
                  {{ $t("about.about27") }}
                  <!-- 完成国内沥青混凝土心墙方量最大土石坝沥青混凝土心墙施工，并研发外出国内外最宽的沥青心墙联合摊铺机 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>
          <!-- 2018 -->
          <div class="time2-item">
            <div class="dot-box2 item2018">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
              <div class="dot-txt2">
                <h5>2018年</h5>
                <p>
                  {{ $t("about.about30") }}
                  <!-- 完成海外沥青混凝土心墙坝项目综合鲁水电站施工建设沥青混凝土心墙施工 -->
                </p>
              </div>
            </div>
          </div>
          <!-- 2017 -->
          <div class="time-item item2017">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2017年</h5>
                <p>
                  {{ $t("about.about26") }}
                  <!-- 完成中国第一座弧形轴线沥青混凝土心墙坝河心水库沥青混凝土心墙施工 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>
          <!-- 2016 -->
          <div class="time2-item">
            <div class="dot-box2 item2016">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
              <div class="dot-txt2">
                <h5>2016年</h5>
                <p>
                  {{ $t("about.about29") }}
                  <!-- 完成国内坝址区海拔最高的沥青混凝土心墙坝恰央水库项目沥青混凝土心墙施工。 -->
                </p>
              </div>
            </div>
          </div>

          <!-- 2014 -->
          <div class="time-item item2014">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2014年</h5>
                <p>
                  {{ $t("about.about25") }}
                  <!-- 完成世界已建最高沥青混凝土心墙土石坝（174.2m）去学水电站工程项目沥青混凝土心墙施工 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>

          <!-- 2012 -->
          <div class="time2-item">
            <div class="dot-box2 item2012">
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
              <div class="dot-txt2">
                <h5>2012年</h5>
                <p>
                  {{ $t("about.about28") }}
                  <!-- 完成玉滩水库沥青混凝土心墙施工，获得中国水利工程大禹奖、中国建设工程鲁班奖 -->
                </p>
              </div>
            </div>
          </div>
          <!-- 2010 -->
          <div class="time-item item2010">
            <div class="dot-box">
              <div class="dot-txt">
                <h5>2010年</h5>
                <p>
                  {{ $t("about.about24") }}
                  <!-- 西安惠泽建设工程有限公司成立正式进入沥青防渗工程领域；
                  完成库什塔依水电站项目沥青混凝土心墙施工，实现-15℃低温环境施工作业 -->
                </p>
              </div>
              <!-- <div class="dot">
                <img src="../assets/image/dev-2.png" alt="" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉证书 -->
    <div class="honor">
      <div class="container">
        <div class="title">{{ $t("about.about201") }}</div>
        <div class="row honor-imgbox">
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <div class="demo-image__preview">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="url3"
                  :preview-src-list="srcList"
                >
                </el-image>
              </div>
              <!-- <img
                src="../assets/image/about-16.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url4"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img
                src="../assets/image/about-17.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url14"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url12"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </div>          
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url13"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </div>

        </div>
      </div>
    </div>

<!-- 获奖证书 -->
<div class="honor">
      <div class="container">
        <div class="title">{{ $t("about.about202") }}</div>
        <div class="row honor-imgbox">

          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url5"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url6"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img
                src="../assets/image/about-17.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

<!-- 参与主编 -->
<div class="honor">
      <div class="container">
        <div class="title">{{ $t("about.about203") }}</div>
        <div class="row honor-imgbox">

          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url7"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url8"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url9"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img
                src="../assets/image/about-17.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url10"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url11"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉资质 -->
    <div class="honor">
      <div class="container">
        <div class="title">{{ $t("about.about31") }}</div>
        <div class="row honor-imgbox">
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <div class="demo-image__preview">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="url"
                  :preview-src-list="srcList"
                >
                </el-image>
              </div>
              <!-- <img
                src="../assets/image/about-16.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url1"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img
                src="../assets/image/about-17.png"
                class="img-fluid"
                alt=""
              /> -->
            </div>
          </div>
          <div class="col-md-4 col-4 honor-item">
            <div class="honor-img">
              <el-image
                style="width: 100%; height: 100%"
                :src="url2"
                :preview-src-list="srcList"
              >
              </el-image>
              <!-- <img :src="url2" class="img-fluid" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>



<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      url: require("../assets/image/about-16.png"),
      url1: require("../assets/image/about-17.png"),
      url2: require("../assets/image/about-18.png"),
      url3: require("../assets/image/zhengshu1.jpg"),
      url4: require("../assets/image/zhengshu2.jpg"),
      url5: require("../assets/image/zhengshu3.jpg"),
      url6: require("../assets/image/zhengshu4.jpg"),
      url7: require("../assets/image/guifan1.jpg"),
      url8: require("../assets/image/guifan2.jpg"),
      url9: require("../assets/image/guifan3.jpg"),
      url10: require("../assets/image/guifan4.jpg"),
      url11: require("../assets/image/guifan5.png"),
      url12: require("../assets/image/zhengshu5.png"),
      url13: require("../assets/image/zhengshu6.jpg"),
      url14: require("../assets/image/zhengshu7.jpg"),


      srcList: [
        require("../assets/image/about-16.png"),
        require("../assets/image/about-17.png"),
        require("../assets/image/about-18.png"),
        require("../assets/image/zhengshu1.jpg"),
        require("../assets/image/zhengshu2.jpg"),
        require("../assets/image/zhengshu3.jpg"),
        require("../assets/image/zhengshu4.jpg"),
        require("../assets/image/guifan1.jpg"),
        require("../assets/image/guifan2.jpg"),
        require("../assets/image/guifan3.jpg"),
        require("../assets/image/guifan4.jpg"),
        require("../assets/image/guifan5.png"),
        require("../assets/image/zhengshu5.png"),
        require("../assets/image/zhengshu6.jpg"),
        require("../assets/image/zhengshu7.jpg"),



      ],
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
  li{
    list-style: none;
  }
.banner {
  background: url("../assets/image/about-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  top: 140px;
  margin-bottom: 140px;
  width: 100%;
  height: 500px;
}
.banner_title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-family: PingFang SC;
  font-style: italic;
  color: #ffffff;
  text-align: center;
}
.title {
  background-position: center;
  background-size: contain;
  font-size: 30px;
  font-weight: 800;
  font-style: italic;
  color: #ffffff;
  text-align: center;
  background-repeat: no-repeat;
}
//公司文化
.culture {
  overflow: hidden;
  .title {
    color: #054ea4;
    background-image: url("../assets/image/about-6.png");
    margin: 108px 0 50px 0;
  }
  .culture-txt {
    background: #054ea4;
    padding: 42px 0;
    margin-bottom: 35px;
    /*display: flex;*/
    justify-content: center;
    font-size: 15px;
    color: #ffffff;
    /*line-height: 33px;*/
    /*margin: 0 ;*/
    /*height: 135px;*/
    /*border: 1px solid red;*/
    /*margin-bottom: ;*/
    p{
      color: #ffffff;
      padding-top: 5px;
    }
    li{
      color: #ffff;
    }
      .culture-left{
          width: 259px;
          color: #ffffff;
          margin: 0 auto;
      }
    .culture-right{
      width: 259px;
      color: #ffffff;
      /*border: 1px solid red;*/
      margin: 0 auto;

    }

  }

  .culture-imgbox {
    display: flex;

    justify-content: space-between;
  }
}
//发展历程
.development {
  background: #f5f5f5;
  padding: 100px 0;
  margin: 100px 0;
  .title {
    background-image: url("../assets/image/about-14.png");
    color: #054ea4;
    margin-bottom: 70px;
  }
  .develop-time {
    display: flex;
    justify-content: space-around;
    background: url("../assets/image/dev-1.png") no-repeat;
    background-position: center;
    background-size: 100%;
    //  padding: 0 40px;
    .time-item {
      width: 20%;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      p {
        text-align: center;
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        line-height: 26px;
      }
      h5 {
        font-weight: 600;
      }
    }
  }
}
.develop-time2 {
  padding: 0 194px;
  display: flex;
  justify-content: space-around;
  font-size: 18px;

  .time2-item {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p {
      text-align: center;
      width: 150px;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 26px;
      margin-top: 20px;
      /*color: red;*/
    }
    h5 {
      font-weight: 600;
    }
  }
}
.develop-time-3 {
  background: url("../assets/image/about-23.png") no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;

  .time-item {
    .dot-box {
      display: flex;

      .dot-txt {
        padding-right: 52px;
        p {
          font-size: 12px;
          color: #343434;
          text-align: right;
        }
        h5 {
          font-size: 15px;
          font-weight: 800;
          font-style: italic;
          color: #343434;
          text-align: right;
        }
      }
    }
  }
  .time2-item {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .dot-box2 {
      display: flex;
      align-items: center;
      .dot-txt2 {
        padding-left: 28px;
        p {
          font-size: 12px;
          color: #343434;
          text-align: left;
        }
        h5 {
          font-size: 15px;
          font-weight: 800;
          font-style: italic;
          color: #343434;
          text-align: left;
        }
      }
    }
  }
}
.item2019 {
  width: 56%;
}
.item2018 {
  width: 60%;
}

.item2017 {
  width: 50%;
  margin-top: 30px;
  .dot-box {
    display: flex;
    align-items: center;
  }
}
.item2016 {
  width: 50%;
  /*color: red;*/
}
.item2021 {
  width: 50%;
  /*color: red;*/
}
.item2022 {
  width: 50%;
  /*color: red;*/
}
.item2023 {
  width: 50%;
  /*color: red;*/
}
.item2014 {
  width: 56%;
  padding-top: 30px;
  .dot-box {
    display: flex;
    align-items: center;
  }
}
.item2012 {
  width: 56%;
}
.item2010 {
  width: 60%;
  .dot-box {
    display: flex;
    align-items: flex-end;
  }
}
.part2010 {
  margin-bottom: 20px;
}
.part2014 {
  margin-bottom: 100px;
}
.part2012 {
  margin-top: -80px;
  // margin-left:-150px;
  padding-left: 60px;

}
.part2016 {
  margin-top: -160px;
  padding: 0 10px;
  padding-left: 60px;

}
.part2018 {
  margin-top: -280px;
  padding-left: 60px;

  // padding-left: 10px;
  // padding-right: 20px;
}
.part2020 {
  margin-top: -300px;
  // margin-left: 100px;
  padding-left: 60px;


}
.part2022 {
  margin-top: -300px;
  // margin-left: 150px;
  padding-left: 60px;

}

.part2017 {
  margin-bottom: 150px;

  padding-right: 48px;
}
.part2019 {
  margin-bottom: 172px;
  padding-right: 40px;
}
.part2021 {
  margin-bottom: 230px;
  padding-right: 0px;
}
.part2023 {
  margin-bottom: 280px;
  padding-right: 10px;
  padding-left: 20px;
}


//荣誉






//荣誉资质
.honor {
  .title {
    color: #054ea4;
    background-image: url("../assets/image/about-15.png");
  }
  .honor-imgbox {
    justify-content: center;
    margin: 50px 0 100px 0;
  }
}

.title-txt-sj {
  display: none;
}
.div-box {
  background: url("../assets/image/about-24.png") no-repeat;
  background-position: center;
  background-size: 100%;
}
@media (max-width: 1024px) and (min-width: 768px) {

  .culture .culture-txt p {
    font-size: 16px;

  }
  .culture .culture-txt[data-v-0eae476b] {
    padding: 22px 3%;
  }
  .brief_item {
    padding: 0 28px;
  }
  .title-txt {
    padding: 10px;
  }
  .title {
    font-size: 18px;
  }
  .title-txt {
    display: none;
  }
  .title-txt-sj {
    display: block;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    margin: 20px 0;
  }
  .banner {
    top: 75px;
    margin-bottom: 75px;
    height: 350px;
  }
  .culture .title {
    margin: 50px 0 44px 0;
  }
  .development {
    margin: 50px 0;
    padding: 50px 0;
  }
  .honor .honor-imgbox {
    margin: 25px 0 50px 0;
  }
}

@media (max-width: 767px) and (min-width: 320px) {
  .banner {
    background-image: url("../assets/image/about-mobile-banner.png");
    background-size: 100%;
    height: 230px;
    top: 50px;
    margin-bottom: 50px;
  }
  .item2016{
    padding-left: 25px;
  }
  .item2014{
    padding-right: 25px;
  }
  .item2012{
    padding-left: 25px;
  }
  .item2018{
    padding-left: 25px;
  }
  .item2010{
    padding-right: 12px;
  }
  .banner_title {
    font-size: 25px;
  }
  .contact {
    .map {
      height: 200px;
      margin-top: 20px;
    }
  }
  .brief {
    display: none;
  }
  .title-txt {
    padding: 10px;
  }
  .title {
    font-size: 18px;
  }
  .title-txt {
    display: none;
  }

  .title-txt-sj {
    display: block;
    font-size: 12px;
    color: #ffffff;
  }
  .culture .culture-txt {
    padding: 0;
    font-size: 12px;
    p,
    span {
      color: #333333 !important;
      line-height: 23px;
    }
  }
  .culture .culture-txt {
    background-color: #ffffff;
    /*display: block;*/
    text-align: left;
    display: flex;
    justify-content: center;
    flex-direction: column;align-items: center;
    color: #333333;
    width: 309px!important;
    margin: 0 auto;
    margin-bottom: 20px;

  }
  .culture-left{
  p{
    width: 426px;
    margin: 0 auto;
    /*background: red;*/
    /*font-size: 18px;*/
  }
    /*font-size: 27.76px;*/
    /*margin-bottom: 50px;*/
    /*background: red;*/
    /*margin: 0 auto;*/
    /*padding-left: -3px;*/
  }
  .culture-right{
    /*font-size: 27.76px;*/
    /*width: 426px;*/
    /*margin: 0 auto;*/
    /*padding-left: 6.7px;*/
    /*margin-bottom: 40px;*/
    p{
      /*width: 426px;*/
      /*padding-left: 10px;*/
      margin-bottom: 0px!important;
    }
    li{
      /*margin-bottom: 20px;*/
    }
  }

  .culture .title {
    margin: 50px 0 23px 0;
  }

  .SJimgshow {
    display: flex;
    margin-top: 10px;
  }
  .SJimg {
    padding-right: 20px;
    margin-bottom: 10px;
  }
  .development .title {
    margin: 50px 0;
  }
  .honor .honor-imgbox {
    margin: 25px 0 50px 0;
  }
  // .middleImg {
  //   position: absolute;
  //   left: 25%;
  //   top: -104%;
  //   z-index: 100;
  //   padding: 0 5px;
  // }
  .culture-imgbox {
    .culture-item1 {
      padding-right: 2px;
      margin-top: 5px;
    }
    .culture-item2 {
      padding-left: 2px;
      margin-top: 5px;
    }
  }
  .honor-item {
    padding-right: 5px;
    padding-left: 5px;
  }
  .development {
    padding: 0;
    background-image: url("../assets/image/aboutus-24.png");
    margin: 50px 0 15px 0;
  }
  .honor {
    background: #f5f5f5;
    overflow: hidden;
    .title {
      margin: 47px 0 25px 0;
    }
  }
}
@media (max-width: 1200px) and (min-width: 992px) {

  .part2010 {
    margin-bottom: 48px;
  }
  .part2014 {
    margin-bottom: 98px;
  }
  .part2012 {
    margin-top: -102px;
    padding-right: 54px;
    margin-left: -10px;
  }
  .part2016 {
    margin-top: -232px;
    color: red;
  }
  .part2018 {
    margin-top: -303px;
    padding-right: 0;
  }
  .part2017 {
    margin-bottom: 170px;
    padding-right: 48px;
  }
  .part2019 {
    margin-bottom: 182px;
  }
  .contact {
    .map {
      background-size: 120% 100%;
    }
  }
}
@media (max-width: 992px) and (min-width: 768px) {

  .part2010 {
    margin-bottom: 75px;
  }
  .part2014 {
    margin-bottom: 127px;
  }
  .part2012 {
    margin-top: -132px;
  }
  .part2016 {
    margin-top: -190px;
  }
  .part2018 {
    margin-top: -230px;
  }
  .part2017 {
    margin-bottom: 170px;
    padding-right: 48px;
  }
  .part2019 {
    margin-bottom: 174px;
  }
  .develop-time2 {
    padding: 0px 115px;
  }
  .development .develop-time .time-item {
    font-size: 14px;
    h5 {
      font-size: 14px;
    }
  }
  .develop-time2 .time2-item {
    font-size: 14px;
    h5 {
      font-size: 14px;
    }
  }
}
</style>
